import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ApiErrors, StoreLoadingEnum} from 'types/global';
import {createApiError} from 'helpers/global';
import {RootState} from "store";
import {MobilePushDto, MobilePushQueryParams} from "types/mobilePush";
import {mobilePushApi} from "../api/mobilePush";

interface NotificationsMobilePushDto {
    loading: StoreLoadingEnum;
    error: string | null;
    data: MobilePushDto | null;
}

const initialState: NotificationsMobilePushDto = {
    loading: StoreLoadingEnum.idle,
    error: null,
    data: null,
}
export const mobilePushThunk = createAsyncThunk<
    MobilePushDto,
    MobilePushQueryParams & { signal?: AbortSignal },
    { rejectValue: ApiErrors }
>(
    'emailLogs/get',
    async (data, thunkAPI) => {
        try {
            return await mobilePushApi.getMobilePush(data, data.signal);
        } catch (e) {
            if (e.name === 'AbortError' || e.code === 'ERR_CANCELED') {
                return thunkAPI.rejectWithValue({message: 'canceled'});
            }
            return thunkAPI.rejectWithValue(createApiError(e));
        }
    }
);

export const mobilePushSlice = createSlice({
    name: 'mobilePush',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(mobilePushThunk.pending, (state) => {
            state.data = null;
            state.loading = StoreLoadingEnum.pending;
            state.error = null;
        });
        builder.addCase(mobilePushThunk.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = StoreLoadingEnum.loaded;
            state.error = null;
        });
        builder.addCase(mobilePushThunk.rejected, (state, action) => {
            if (!action.payload || action.payload.message === 'canceled') return;

            state.data = null;
            state.loading = StoreLoadingEnum.loaded;
            state.error = action.payload?.message || null;
        });
    },
});

export const selectMobilePushDataSelector = (state: RootState) => state.mobilePush.data?.content;
export const selectMobilePushLoadingSelector = (state: RootState) => state.mobilePush.loading;
export const selectMobilePushErrorSelector = (state: RootState) => state.mobilePush.error;
export const currentOffsetSelector = (state: RootState) => state.mobilePush.data?.pageable.offset ?? 0;
export const totalElementsSelector = (state: RootState) => state.mobilePush.data?.totalElements ?? 0;
export const currentPageSizeSelector = (state: RootState) => state.mobilePush.data?.pageable.pageSize ?? 0;